<div *ngIf="Control" [formGroup]="Group" class="mt-2">
  <div class="w-100 text-center">
    <button mat-flat-button color="accent" type="button" class="btn-sm" id="label_{{Control.label}}"
      [translation]="TranslationEnum.TranslationForm" (click)="openPdf()">
      {{('label_'+ Control.label)|translate}}
    </button>
  </div>
</div>
